export default __webpack_public_path__ + "static/media/blogjananogueira.9a6162a6.jpg";